import React from 'react';
import { cn } from '../../../utils/cn';
import { spinnerVariants } from './Spinner.styles';
import { SpinnerProps } from './Spinner.types';

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ className, size, color, label, 'aria-label': ariaLabel = 'Loading', ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('inline-flex flex-col items-center gap-2', className)}
        role="status"
        aria-label={ariaLabel}
        {...props}
      >
        <div className={cn(spinnerVariants({ size, color }))} aria-hidden="true" />
        {label && (
          <span
            className={cn(
              'text-sm',
              color === 'white' ? 'text-white' : 'text-gray-600 dark:text-slate-400'
            )}
          >
            {label}
          </span>
        )}
        <span className="sr-only">{ariaLabel}</span>
      </div>
    );
  }
);

Spinner.displayName = 'Spinner';
